import { render, staticRenderFns } from "./UserNeedHelpDropdown.vue?vue&type=template&id=957db6ba&scoped=true&"
import script from "./UserNeedHelpDropdown.vue?vue&type=script&lang=js&"
export * from "./UserNeedHelpDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "957db6ba",
  null
  
)

export default component.exports